"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlusIcon = void 0;
var react_1 = __importDefault(require("react"));
var build_svg_icon_1 = require("./build-svg-icon");
exports.PlusIcon = (0, build_svg_icon_1.buildSvgIcon)(react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.5 11V5C11.5 4.44772 11.9477 4 12.5 4C13.0523 4 13.5 4.44772 13.5 5V11H19.5C20.0523 11 20.5 11.4477 20.5 12C20.5 12.5523 20.0523 13 19.5 13H13.5V19C13.5 19.5523 13.0523 20 12.5 20C11.9477 20 11.5 19.5523 11.5 19V13H5.5C4.94772 13 4.5 12.5523 4.5 12C4.5 11.4477 4.94772 11 5.5 11H11.5Z", fill: "#282827" }), 'PlusIcon');
exports.default = exports.PlusIcon;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGx1c0ljb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9pY29ucy9QbHVzSWNvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsZ0RBQTBCO0FBQzFCLG1EQUFnRDtBQUVuQyxRQUFBLFFBQVEsR0FBRyxJQUFBLDZCQUFZLEVBQ2xDLHdDQUNFLFFBQVEsRUFBQyxTQUFTLEVBQ2xCLFFBQVEsRUFBQyxTQUFTLEVBQ2xCLENBQUMsRUFBQyxpU0FBaVMsRUFDblMsSUFBSSxFQUFDLFNBQVMsR0FDZCxFQUNGLFVBQVUsQ0FDWCxDQUFDO0FBRUYsa0JBQWUsZ0JBQVEsQ0FBQyJ9


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/icons/icons/PlusIcon.js
// module id = 3484
// module chunks = 25